import React from 'react';
import ReactIframeResizer from 'react-iframe-resizer-super';
import { navigateTo } from 'gatsby-link';

import Page from 'marketing-website/components/modules/Page';

export default function PricingPage() {
  const iframeResizerOptions = {
    checkOrigin: false,
    autoResize: true,
    inPageLinks: true,
    messageCallback({ message }) {
      navigateTo(message);
    },
    heightCalculationMethod: 'taggedElement',
  };

  return (
    <Page
      title="Overview of Marvel | Marvel University"
      meta={[
        {
          name: 'description',
          content:
            'An introduction into the Marvel platform including Prototyping, Design & User Testing',
        },
        {
          name: 'keywords',
          content:
            'marvel, university, tutorials, overview, user-testing, course',
        },
      ]}
      header
      footer
    >
      <div style={{ height: 24 /* for header bar */ }} />
      <ReactIframeResizer
        iframeResizerOptions={iframeResizerOptions}
        iframeResizerEnable
        src="/university/prototyping-basics"
        style={{ width: '100%', minHeight: 800 }}
      />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/university/course/overview-of-marvel.js